import type { BackendApi } from '../backend/client'

/** Triggers an immediate itemized-bill request for an expense. */
export function sendItemizedBillNow(api: BackendApi, expenseId: string) {
  return api.sendItemizedBillNow({ expense_id: expenseId })
}

/**
 * Manually links a Plaid-imported draft expense onto an existing expense: the
 * draft's bank charge is recorded as a payment on the target and the draft is
 * soft-deleted. Both changes arrive through the ordinary sync-down, so callers
 * should not optimistically mutate Redux themselves -- see the JSDoc on
 * apps/web/src/app/hooks/useLinkDraftToExpense.ts.
 */
export function linkPlaidDraftToExpense(api: BackendApi, draftExpenseId: string, targetExpenseId: string) {
  return api.linkPlaidDraftToExpense({
    draft_expense_id: draftExpenseId,
    target_expense_id: targetExpenseId,
  })
}
